var map = {
	"./bd-active.webp": "ZMfR",
	"./bd-default.webp": "gZyH",
	"./im-active.webp": "fjsR",
	"./im-default.webp": "UIOC",
	"./logo_bd.webp": "kKsX",
	"./logo_im.webp": "ItM0",
	"./logo_sb.webp": "uOjx",
	"./logo_ss.webp": "KJuo",
	"./sb-active.webp": "spKp",
	"./sb-default.webp": "nAh5",
	"./sportGame1.webp": "gpBO",
	"./sportGame2.webp": "B/q7",
	"./sportGame3.webp": "QYwH",
	"./sportGame4.webp": "ejGr",
	"./ss-active.webp": "4Fdi",
	"./ss-default.webp": "GddS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Sl+H";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/sport ^\.\/.*\.webp$
// module id = Sl+H
// module chunks = 3